import { useDict } from '../../i18n/dictionary';
import { api } from '../../lib/api';
import {
  useCreateResource,
  useDeleteResource,
  useResourceQuery,
  useUpdateResource,
} from '../../lib/crud';
import { recipesDict } from './i18n';

// One key for the whole app: the list holds every recipe whole, and the
// cooking view and the form read their recipe out of it.
const RECIPES = ['recipes'] as const;

export function useRecipes() {
  const t = useDict(recipesDict);
  return useResourceQuery(
    RECIPES,
    () => api.recipes.listRecipes(),
    t.loadFailed,
  );
}

export function useCreateRecipe() {
  const t = useDict(recipesDict);
  return useCreateResource(
    RECIPES,
    api.recipes.createRecipe,
    t.createFailed,
    t.created,
  );
}

export function useUpdateRecipe() {
  const t = useDict(recipesDict);
  return useUpdateResource(
    RECIPES,
    api.recipes.updateRecipe,
    t.updateFailed,
    t.updated,
  );
}

export function useDeleteRecipe() {
  const t = useDict(recipesDict);
  return useDeleteResource(RECIPES, api.recipes.deleteRecipe, t.deleteFailed);
}
